export default "__VITE_ASSET__Dzc5nEJS__"